// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"f8475b81","256":"ba668054","403":"ff2c9934","617":"415ab232","904":"367443ec"}[chunkId] + ".chunk.js";
};